@if (multimedia(); as multimedia) {
  @if (multimedia.type === 'image') {
    <img class="object-fill" [src]="multimedia.src" class="flex-1 h-full" />
  } @else if (multimedia.type === 'video') {
    <video class="h-full w-full object-fill" autoplay [muted]="multimedia.muted ?? false" loop>
      <source [src]="multimedia.src" type="video/mp4" />
      El navegador no soporta el video.
    </video>
  }
}
